//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getNodeList, setNode, delNode } from "@/api/management/showcase";
export default {
  name: "Note",
  props: ["itemData", "type"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      value: new Date(),
      data: {
        noteText: ""
      },
      colorList: [{
        value: "#ffdf20",
        color: "#ffdf20"
      }, {
        value: "#ff9634",
        color: "#ff9634"
      }, {
        value: "#abff3d",
        color: "#abff3d"
      }, {
        value: "#ff58c1",
        color: "#ff58c1"
      }, {
        value: "#3aa4ff",
        color: "#3aa4ff"
      }],
      modelColor: "#ffdf20",
      nodeTitleList: [],
      showColor: "#d0d0d0",
      textShow: false,
      showText: "",
      colorNum: "",
      num: 0
    };
  },
  mounted: function mounted() {
    this.getNodeListData();
  },
  methods: {
    setDelNode: function setDelNode() {
      var _this = this;

      delNode(this.nodeId || "").then(function (res) {
        if (res.data.code == 0) {
          _this.getNodeListData();

          _this.textShow = false;
          _this.showText = "";
        } else {
          _this.$message.warning(res.msg);
        }
      });
    },
    getNodeListData: function getNodeListData() {
      var _this2 = this;

      var params = {
        len: 10000,
        pos: 1
      };
      getNodeList(params).then(function (_ref) {
        var data = _ref.data;
        _this2.nodeTitleList = data.data.reverse();

        if (_this2.type == "index") {
          _this2.showColor = _this2.nodeTitleList[0].color;
          _this2.textShow = true;
        }
      });
    },
    colorClick: function colorClick(item) {
      this.modelColor = item.value;
    },
    inputShow: function inputShow() {
      this.textShow = false;
    },
    titleClick: function titleClick(item) {
      this.showColor = item.color;
      this.textShow = true;
      this.showText = item.content;
      this.nodeId = item.id;
    },
    // 添加标签
    addSc: function addSc() {
      var _this3 = this;

      if (this.data.noteText != "") {
        var params = {
          color: this.modelColor || "",
          content: this.data.noteText || "",
          id: ""
        };
        setNode(params).then(function (res) {
          if (res.data.code == 0) {
            _this3.getNodeListData();

            _this3.data.noteText = "";
          } else {
            _this3.$message.warning(res.msg);
          }
        });
      } else {
        this.$message.warning("请完善标签内容");
      }
    },
    // 删除标签
    delNote: function delNote() {// this.textShow = false
    },
    handleClose: function handleClose(done) {
      this.$confirm("确认关闭？").then(function (_) {
        done();
      }).catch(function (_) {});
    }
  }
};